import styled from "styled-components";

const Wrapper = styled.div`
  padding: 100px 0;
  background: var(--bg-color);

  @media (max-width: 600px) {
    padding: 60px 0 40px;
  }

  .container {
    h3 {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 70px;
      font-family: 'Playfair Display', serif;
      font-size: 2.5rem;

      @media (max-width: 600px) {
        font-size: 2rem;
        margin-bottom: 40px;
      }
    }

    .item-container {
      display: flex;
      align-items: stretch; /* Cards same height */
      justify-content: center;
      flex-wrap: wrap;
      gap: 30px;

      .item {
        width: 330px;
        min-height: 450px;
        background: white;
        border-radius: var(--radius);
        box-shadow: var(--shadow-sm);
        text-align: center;
        overflow: hidden;
        transition: var(--transition);
        display: flex;
        flex-direction: column;

        &:hover {
          transform: translateY(-10px);
          box-shadow: var(--shadow-md);
        }

        h4 {
          font-size: 1.4rem;
          color: white;
          padding: 25px 0;
          background-color: var(--primary-color);
          margin: 0;
          font-family: 'Playfair Display', serif;
          letter-spacing: 0.5px;
          border-bottom: 3px solid var(--secondary-color);
        }

        .content {
          background-color: #f4f6f8; /* Light gray contrast */
          padding: 30px 20px;
          color: var(--primary-color);
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .starting {
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #777;
            margin-bottom: 5px;
          }

          .price {
            font-size: 2rem;
            font-weight: 700;
            color: var(--primary-color);
            font-family: 'Lato', sans-serif;
          }
          
          p {
            font-size: 1rem;
            color: #555;
            margin-top: 5px;
          }
        }

        .list {
          padding: 30px 20px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;

          h5 {
            font-size: 1.2rem;
            color: var(--primary-color);
            font-weight: 700;
            margin-bottom: 20px;
            text-align: center;
            font-family: 'Playfair Display', serif;
          }
          ul {
            text-align: left;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            gap: 12px;

            li {
              font-size: 1.05rem;
              display: flex;
              align-items: flex-start;
              gap: 10px;
              color: #555;
              
              .check-icon {
                color: var(--secondary-color);
                font-size: 1.2rem;
                flex-shrink: 0;
                margin-top: 4px;
              }
            }
          }
        }
        
        .details {
          color: #555;
          line-height: 1.6;
        }

        /* Special styling for CTA button if added later */
      }
    }

    .dnone {
      @media (min-width: 450px) {
        display: none;
      }
    }
  }
`;

export default Wrapper;
